import { useState, useEffect } from "react";
import steps from "../util/tutorialwalkthrough.json";

const useTooltipTutorialhook = (run) => {
  const [filteredSteps, setFilteredSteps] = useState([]);
  const [loading, setLoading] = useState(false); // <-- new loading state

  useEffect(() => {
    if (!run) {
      setFilteredSteps([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    let retries = 3;

    const checkTargets = () => {
      const validSteps = steps.filter(step =>
        document.querySelector(step.target)
      );

      if (validSteps.length === steps.length || retries === 0) {
        setFilteredSteps(validSteps);
        setLoading(false);
      } else {
        retries--;
        setTimeout(checkTargets, 300);
      }
    };

    checkTargets();
  }, [run]);

  return { filteredSteps, loading };
};

export default useTooltipTutorialhook;
